import { axios } from "@/plugins/http-request.js";

const state = {};

const getters = {};

const actions = {
  downloadProductTemplate() {
    return axios
      .get(
        `/api/file_download?file_path=fulfillments/sku_upload_template.xlsx`,
        {
          responseType: "blob",
        }
      )
      .then((res) => res);
  },
  uploadProductExcel(context, payload) {
    return axios
      .post("/api/fulfillment/sku_import", payload)
      .then((res) => res.data);
  },
  getProductList(context, payload) {
    return axios
      .get("/api/fulfillment/sku_list", {
        params: payload,
      })
      .then((res) => res.data);
  },
  getSkuList(context, payload) {
    return axios
      .get("/api/fulfillment/skus", {
        params: payload,
      })
      .then((res) => res.data);
  },
  getTagsList(context, id) {
    return axios
      .get(`/api/fulfillment/sku_tag_list?client_id=${id}`)
      .then((res) => res.data);
  },
  downloadSkuList(_, payload) {
    return axios
      .get("/api/fulfillment/download_skus", {
        params: payload,
        responseType: "blob",
      })
      .then((res) => res);
  },
  uploadSku(context, payload) {
    return axios
      .post("/api/fulfillment/upload_sku_client_mapping", payload)
      .then((res) => res.data);
  },
  syncSKuList() {
    return axios.get("/api/fulfillment/sku_sync").then((res) => res.data);
  },
  downloadSkuTemplate() {
    return axios
      .get(`/api/file_download?file_path=fulfillments/sku_mapping.xlsx`, {
        responseType: "blob",
      })
      .then((res) => res);
  },
  getTransportList(context, payload) {
    return axios
      .get("/api/dow-orders", {
        params: payload,
      })
      .then((res) => res.data);
  },
  transportTracking(_, id) {
    return axios.get(`/api/click-rf-events/${id}`).then((res) => res.data);
  },
  downloadTransport() {
    return axios
      .get(
        `/api/file_download?file_path=/transport_templates/transport_orders.xlsx`,
        {
          responseType: "blob",
        }
      )
      .then((res) => res);
  },
  uploadTransport(context, payload) {
    return axios.post("/api/dow-orders-post", payload).then((res) => res.data);
  },
};

const mutations = {};

export default {
  state,
  getters,
  actions,
  mutations,
};
